import React from 'react';
import { CircleAlert } from 'lucide-react';
import { explainerSlugKey } from 'src/shared/constants/portfolio';
import { PortfolioData } from 'src/app/portfolio/state/api/portfolioQuery';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import SummaryCard from './SummaryCard';
import PortfolioExploreButton from './PortfolioExploreButton';

const InvasiveSpeciesChart = ({ portfolioData }: { portfolioData: PortfolioData }) => {
    const navigate = useAppNavigation();
    // See IucnSummaryCard: Explore follows the source the card's figures came from.

    const invasiveSpecies = portfolioData.summary.predictedSpeciesSummary?.invasiveSpecies;
    if (!invasiveSpecies) {
        return null;
    }

    return (
        <SummaryCard
            dataTestId='portfolio-invasive-species-card'
            containerClasses='gap-3 p-5'
            cardIcon={<CircleAlert className='text-red-100' />}
            cardTitle='Invasive Species'
            cardSubtitle='Possible invasive species overlap across portfolio'
            titleExplainerSlug={{
                defaultSlug: explainerSlugKey.portfolioInvasiveSpecies,
                explainerSlug: `${explainerSlugKey.portfolioInvasiveSpecies}-te`,
            }}
            cardBody={
                <div className='flex gap-4'>
                    <div className='flex flex-col'>
                        <div className='flex gap-2 items-end'>
                            <span className='text-[42px] text-grey-80'>{invasiveSpecies.siteCount}</span>
                            <span className='text-xl text-grey-80 pb-3'>
                                ({Math.round((invasiveSpecies.siteCount / portfolioData.summary.numberSites) * 100)}%)
                            </span>
                        </div>
                        <div className='text-sm text-grey-80'>
                            Sites with possible
                            <br />
                            invasive species
                        </div>
                    </div>
                    <div className='bg-grey-20 w-[1px]'>&nbsp;</div>
                    <div className='flex flex-col'>
                        <div className='flex gap-2 items-end'>
                            <span className='text-[42px] text-grey-80'>{invasiveSpecies.count}</span>
                        </div>
                        <div className='text-sm text-grey-80'>
                            Total invasive
                            <br />
                            species
                        </div>
                    </div>
                </div>
            }
            action={
                <PortfolioExploreButton
                    sectionName='invasive-species'
                    onClick={() => navigate.toPortfolioSpeciesRiskIndicators({ tab: 'invasive-species' })}
                />
            }
            frameworks={invasiveSpecies.frameworks}
        />
    );
};

export default InvasiveSpeciesChart;
